import Axios from "axios";
import { Toast } from 'vant';
import { AD_URL } from "@/assets/api"

function request(option) {
    if (Object.prototype.toString.call(option) !== '[object Object]'){
        console.log('not a object')
        return
    }
    option.method = option.method ? option.method.toUpperCase() : 'GET'
    option.data = option.data || {}

    if(option.method == 'POST'){
      if(option.contentType && option.contentType.indexOf('application/json') != -1){
        option.data = JSON.stringify(option.data)
      }else{
        if(Object.prototype.toString.call(option.data) == '[object Object]'){
          var formData = []
          for (var key in option.data) {
            formData.push(''.concat(key, '=', option.data[key]))
          }
          option.data = formData.join('&')
        }
      }
    }else{
      if(Object.prototype.toString.call(option.data) == '[object Object]'){
        var formData = []
        for (var key in option.data) {
          formData.push(''.concat(key, '=', option.data[key]))
        }
        option.data = formData.join('&')
      }
    }
  
    if (option.method === 'GET') {
      option.url += option.url.indexOf('?') == -1 ? ''.concat('?', option.data) : ''.concat('&', option.data)
    }

    var xhr = new XMLHttpRequest()
    xhr.responseType = option.responseType || 'json'
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {

        if (xhr.status === 200) {
          if (option.success && typeof option.success === 'function') {
            option.success(xhr.response)
          }
        } else {
          if (option.error && typeof option.error === 'function') {
            if(option.url.indexOf(AD_URL) == -1) option.error()
            // option.error()
          }
        }
      }
    }
    xhr.open(option.method, option.url, true)
    xhr.timeout = option.timeout || 10000
    xhr.ontimeout = function(e){
        if(option.url.indexOf(AD_URL) == -1) Toast.fail('请检查网络')
    }
    if (option.method === 'POST') {
      var contentType = 'application/x-www-form-urlencoded'
      if(option.contentType){
        contentType = option.contentType
      }
      xhr.setRequestHeader('Content-Type', contentType)
    }
    xhr.send(option.method === 'POST' ? option.data : null)
}

export default request


// WEBPACK FOOTER //
// ./src/assets/ajax.js